import React, { useEffect } from "react";
import "./manualprocedimientos.css";

const ManualProcedimientos = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container manualprocedimientos-container">
      <div className="row">
        <div className="col_12">
          <div className="manualprocedimientos_title">
            <h1>Manual de Procedimientos</h1>
          </div>
        </div>
      </div>

      <hr className="hr-gob" />
      <div>
        <iframe
          src="https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/DocsPagweb/ManualProcedimientos.pdf"
          height="1500"
          width="1110"
        ></iframe>
      </div>
    </div>
  );
};

export default ManualProcedimientos;
